import React from "react";
import { useReactAppState } from "../../containers/utils";
import { composeGeoLocatedProviders } from "../../utils";
import {
  StyledVenueBroadcasterBar,
  StyledVenueBroadcasterBarWrapper,
  StyledSeparator,
  StyledVenueBroadcasterWrapper,
} from "./StyledVenueBroadcasterBar";
import DividedVenueBroadcaster from "./DividedVenueBroadcaster";

const VenueBroadcasterBar = ({
  venue,
  mediaProviders,
  breakStadiumAndBroadcaster,
}) => {
  const { location } = useReactAppState();
  const { country } = location || {};
  const { streaming, national, radio } = composeGeoLocatedProviders(
    mediaProviders,
    country
  );
  const internationalStreamers =
    mediaProviders?.allProvidersList?.filter(
      (provider) =>
        provider?.broadcasterTypeLabel === "brd_type_international_streaming"
    ) || [];
  const {
    homeLinear,
    awayLinear,
    homeStreaming,
    awayStreaming,
    clubLinear,
    clubStreaming,
    clubRadio,
  } = mediaProviders || {};
  const mergedProviders = [
    ...internationalStreamers,
    ...national,
    ...streaming,
    ...radio,
    ...(homeLinear != null ? homeLinear : []),
    ...(awayLinear != null ? awayLinear : []),
    ...(homeStreaming != null ? homeStreaming : []),
    ...(awayStreaming != null ? awayStreaming : []),
    ...(clubLinear != null ? clubLinear : []),
    ...(clubStreaming != null ? clubStreaming : []),
    ...(clubRadio != null ? clubRadio : []),
  ];

  const mergedProvidersText = mergedProviders
    ?.filter((provider) => provider?.broadcasterName)
    ?.flatMap((provider) => provider?.broadcasterName)
    .join(", ");

  if (breakStadiumAndBroadcaster) {
    if (venue?.name || mergedProvidersText) {
      return (
        <DividedVenueBroadcaster
          venue={venue}
          mergedProvidersText={mergedProvidersText}
        />
      );
    }
  }

  if (mergedProviders?.length === 1 && venue?.name) {
    return (
      <StyledVenueBroadcasterBar className="mls-c-venue-broadcaster-bar --single-broadcaster">
        {venue.name}
        <StyledSeparator className="mls-c-venue-broadcaster-bar__dot">
          •
        </StyledSeparator>
        {mergedProviders[0].broadcasterName}
      </StyledVenueBroadcasterBar>
    );
  }

  return (
    <StyledVenueBroadcasterBarWrapper className="mls-c-venue-broadcaster-bar-wrapper">
      {venue?.name ? (
        <StyledVenueBroadcasterBar className="mls-c-venue-broadcaster-bar">
          {venue?.name}
        </StyledVenueBroadcasterBar>
      ) : null}
      {venue?.name && mergedProvidersText && (
        <StyledSeparator className="mls-c-venue-broadcaster-bar__dot">
          •
        </StyledSeparator>
      )}
      {mergedProvidersText ? (
        <StyledVenueBroadcasterBar className="mls-c-venue-broadcaster-bar">
          {mergedProvidersText}
        </StyledVenueBroadcasterBar>
      ) : null}
    </StyledVenueBroadcasterBarWrapper>
  );
};
export default VenueBroadcasterBar;
